import * as yup from "yup";

export const employeeFormSchema = yup.object({
  name: yup.string().required("required").min(2),
  basic_salary: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue === null ? undefined : value,
    )
    .typeError("required")
    .required("required"),
  description: yup.string().nullable(),
  allowances: yup.array().of(
    yup.object({
      id: yup.number().optional(),
      name: yup.string().required("required"),
      amount: yup
        .number()
        .transform((value, originalValue) =>
          originalValue === "" || originalValue === null ? undefined : value,
        )
        .typeError("required")
        .required("required"),
    }),
  ),
});

export type EmployeeFormValues = yup.InferType<typeof employeeFormSchema>;

export const employeeFormDefaultValues: EmployeeFormValues = {
  name: "",
  basic_salary: 0,
  description: "",
  allowances: [],
};
